/* rein-load-more — 2026-10-15 (the owner: 12 products per page + "Load more" button, not infinite scroll).
 * The collection grid renders 12 cards; this script reveals a "Load more" button and appends the next 12 by fetching the
 * same URL the numbered pagination uses (paginate.next.url keeps sort_by and filter.* params, so sort and filters carry over).
 * Without JS (or for crawlers) the numbered pagination links stay in the HTML. Event delegation: the facet filter AJAX
 * re-renders #ProductGridContainer, so the button and its handler survive filter/sort changes. New cards are picked up by
 * rein-card-extras.js (Arrives dates) and the Affirm widget through their own MutationObservers. */
(function () {
  'use strict';
  document.documentElement.classList.add('rein-more-js');
  function setBusy(btn, on) { btn.disabled = on; btn.setAttribute('aria-busy', on ? 'true' : 'false'); btn.textContent = on ? 'Loading…' : (btn.getAttribute('data-label') || 'Load more'); }
  function updateCount(wrap, shown, total) {
    var c = wrap.querySelector('.rein-more__count');
    if (c && total) c.textContent = 'Showing ' + shown + ' of ' + total + ' products';
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-rein-more]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var url = btn.getAttribute('data-next'); if (!url) return;
    var wrap = btn.closest('.rein-more'); var grid = document.getElementById('product-grid');
    if (!grid || !wrap) return;
    setBusy(btn, true);
    fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        var have = {}; Array.prototype.forEach.call(grid.querySelectorAll('a.js-product-link'), function (a) { have[a.getAttribute('href').split('?')[0]] = 1; });
        var added = 0;
        Array.prototype.forEach.call(items, function (li) {
          var a = li.querySelector('a.js-product-link'); var key = a ? a.getAttribute('href').split('?')[0] : null;
          if (key && have[key]) return;
          grid.appendChild(document.importNode(li, true)); added++;
        });
        var next = doc.querySelector('[data-rein-more]');
        var total = parseInt(wrap.getAttribute('data-total') || '0', 10);
        var shown = grid.querySelectorAll('li').length;
        if (next && next.getAttribute('data-next')) { btn.setAttribute('data-next', next.getAttribute('data-next')); setBusy(btn, false); }
        else { wrap.classList.add('rein-more--done'); btn.hidden = true; }
        updateCount(wrap, shown, total);
        document.dispatchEvent(new CustomEvent('rein:products-appended', { detail: { added: added } }));
        if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) { try { window.affirm.ui.refresh(); } catch (_) {} }
      })
      .catch(function () { setBusy(btn, false); var c = wrap.querySelector('.rein-more__count'); if (c) c.textContent = 'Could not load more. Use the page links below.'; wrap.classList.add('rein-more--error'); });
  });
})();
